<template>
  <div class="hint">
    <h1>Indice n°{{ hintIndex }}</h1>
    <div class="close" @click="$emit('close')">❌</div>
    <p v-if="displayContent">
      <span v-html="innerText"></span>
    </p>
    <div v-if="!displayContent">
      <p>{{warningMessage}}</p>
      <div class="button-wrapper">
        <button class="green" @click="confirm()">Oui</button>
        <button class="red" @click="$emit('close')">Non</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: String,
    warning: { type: String, default: "Lire cet indice ?" },
    read: { type: Boolean, default: false },
    index: { type: Number, default: 1 }
  },
  data() {
    return {
      innerText: this.content,
      warningMessage: this.warning,
      hintIndex: this.index + 1,
      displayContent: this.read
    };
  },
  methods: {
    confirm() {
      this.$emit("continue");
      this.displayContent = true;
    }
  }
};
</script>

<style scoped>
.hint {
  background: #ebc134;
  border: 10px solid #122130;
  font-family: "IBM Plex Mono", monospace;
  color: #122130;
  font-size: 14px;
  padding: 10px;
  position: fixed;
  height: auto;
  max-height: 80vh;
  width: 50vw;
  z-index: 90;
  top: 20vh;
  left: 25vw;
}
.hint h1 {
  font-size: 200%;
}
.hint p {
  font-size: 150%;
}
.close {
  position: absolute;
  top: 2%;
  right: 1%;
}
.close:hover {
  cursor: pointer;
}
.button-wrapper {
  display: flex;
  justify-content: space-evenly;
}
.button-wrapper button {
  height: 20%;
  color: white;
  border: none;
  font-weight: bold;
  padding: 10px;
  border-radius: 15%;
}
.button-wrapper button:hover {
  cursor: pointer;
}
.button-wrapper button:focus {
  outline: none;
}
.green {
  background: #01593b;
}
.red {
  background: #ce322c;
}
</style>
